import { render, staticRenderFns } from "./TabbarMobile.vue?vue&type=template&id=3add9fde&scoped=true&"
import script from "./TabbarMobile.vue?vue&type=script&lang=js&"
export * from "./TabbarMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add9fde",
  null
  
)

export default component.exports